var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatewayUnselect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1592D2",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3295 14.3295C12.7688 13.8902 13.4812 13.8902 13.9205 14.3295L17.6707 18.0798L16.8295 20.4205L12.3295 15.9205C11.8902 15.4812 11.8902 14.7689 12.3295 14.3295Z",
    fill: "#062A41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6705 14.3295C35.2311 13.8902 34.5188 13.8902 34.0795 14.3295L30.3292 18.0798L31.1705 20.4205L35.6705 15.9205C36.1098 15.4812 36.1098 14.7689 35.6705 14.3295Z",
    fill: "#062A41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.75H15.75V18.875C15.75 18.2537 16.2537 17.75 16.875 17.75C17.4963 17.75 18 18.2537 18 18.875V26.75Z",
    fill: "#1592D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 26.75H32.2499V18.875C32.2499 18.2537 31.7463 17.75 31.1249 17.75C30.5036 17.75 29.9999 18.2537 29.9999 18.875V26.75Z",
    fill: "#1592D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0523 33.5H14.6977C14.4233 33.5 14.1725 33.345 14.0498 33.0996L13.5 32L15.75 31.25L17.25 32L16.7002 33.0996C16.5775 33.345 16.3267 33.5 16.0523 33.5Z",
    fill: "#1592D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5523 25.25H18.4477C18.1733 25.25 17.9225 25.405 17.7998 25.6504L17.25 26.75L19.5 27.5L30.75 26.75L30.2002 25.6504C30.0775 25.405 29.8267 25.25 29.5523 25.25Z",
    fill: "#86D6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9476 33.5H33.3022C33.5766 33.5 33.8274 33.345 33.9501 33.0996L34.4999 32L32.2499 31.25L30.7499 32L31.2997 33.0996C31.4225 33.345 31.6732 33.5 31.9476 33.5Z",
    fill: "#1592D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2756 32H12.7244C12.3243 32 12 31.6757 12 31.2756V27.4743C12 27.0743 12.3243 26.75 12.7244 26.75H35.2756C35.6757 26.75 36 27.0743 36 27.4744V31.2757C36 31.6757 35.6757 32 35.2756 32Z",
    fill: "#86D6FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2756 26.75H34.9376V29.5724C34.9376 30.3797 34.2831 31.0342 33.4758 31.0342H12V31.2756C12 31.6757 12.3243 32 12.7244 32H35.2756C35.6757 32 36 31.6757 36 31.2756V27.4743C36 27.0743 35.6757 26.75 35.2756 26.75Z",
    fill: "#86D6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3964 28.25H19.8516L19.4966 29.0095L19.1484 28.25H18.3516L18.0167 29.0536L17.6484 28.25H16.8516L16.5167 29.0536L16.1484 28.25H15.3516L15 29.0937L14.6484 28.25H14.1036C13.7702 28.25 13.5 28.5202 13.5 28.8536V29.8964C13.5 30.2298 13.7702 30.5 14.1036 30.5H14.6484L15 29.6562L15.3516 30.5H16.1484L16.5167 29.6964L16.8516 30.5H17.6484L18.0167 29.6964L18.3516 30.5H19.1484L19.5347 29.6571L19.8516 30.5H20.3964C20.7298 30.5 21 30.2298 21 29.8964V28.8536C21 28.5202 20.7298 28.25 20.3964 28.25Z",
    fill: "#1592D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1484 28.25H16.8516V30.5H16.1484V28.25Z",
    fill: "#219EDE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6484 28.25H15.3516V30.5H14.6484V28.25Z",
    fill: "#219EDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1484 28.25H19.8516V30.5H19.1484V28.25Z",
    fill: "#219EDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6484 28.25H18.3516V30.5H17.6484V28.25Z",
    fill: "#062A41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7499 30.125C31.1642 30.125 31.4999 29.7892 31.4999 29.375C31.4999 28.9608 31.1642 28.625 30.7499 28.625C30.3357 28.625 29.9999 28.9608 29.9999 29.375C29.9999 29.7892 30.3357 30.125 30.7499 30.125Z",
    fill: "#FFC344"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7499 30.125C34.1642 30.125 34.4999 29.7892 34.4999 29.375C34.4999 28.9608 34.1642 28.625 33.7499 28.625C33.3357 28.625 32.9999 28.9608 32.9999 29.375C32.9999 29.7892 33.3357 30.125 33.7499 30.125Z",
    fill: "#FF556C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23C24.6213 23 25.125 22.4963 25.125 21.875C25.125 21.2537 24.6213 20.75 24 20.75C23.3787 20.75 22.875 21.2537 22.875 21.875C22.875 22.4963 23.3787 23 24 23Z",
    fill: "#219EDE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5015 18.5063C23.009 17.4979 24.991 17.4979 26.4985 18.5063C26.8851 18.7649 26.9352 19.3147 26.6063 19.6437L26.5933 19.6567C26.3411 19.9089 25.9483 19.9407 25.6507 19.7442C24.6526 19.0852 23.3474 19.0852 22.3493 19.7442C22.0517 19.9407 21.659 19.9089 21.4068 19.6567L21.3937 19.6437C21.0648 19.3148 21.1149 18.7649 21.5015 18.5063Z",
    fill: "#219EDE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6817 16.3898C25.9518 14.2034 22.0482 14.2034 19.3183 16.3898C18.9693 16.6693 18.9401 17.1902 19.2563 17.5063C19.5284 17.7784 19.9598 17.7973 20.2605 17.5572C22.4422 15.8143 25.5577 15.8143 27.7394 17.5572C28.04 17.7973 28.4715 17.7785 28.7436 17.5063C29.0599 17.1901 29.0307 16.6693 28.6817 16.3898Z",
    fill: "#219EDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayUnselect);
export default __webpack_public_path__ + "static/media/gatewayUnselect.f8421a4a28716cf4aaacae228c99fda7.svg";
export { ForwardRef as ReactComponent };